import { EmailMessageThreadDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { CheckCircle, Mail, Trash2 } from 'lucide-react';

interface EmailMessageThreadActionHandlers {
  onDelete: (thread: EmailMessageThreadDTO) => Promise<void>;
  onMarkAsReplied?: (thread: EmailMessageThreadDTO) => Promise<void>;
  onMarkAsResolved?: (thread: EmailMessageThreadDTO) => Promise<void>;
}

const createEmailMessageThreadActions =
  (handlers: EmailMessageThreadActionHandlers) =>
  (row: EmailMessageThreadDTO): TableAction[] => {
    const actions: TableAction[] = [];

    // Only show "Mark as Resolved" if the status is not already Resolved or Closed
    const currentStatus = row.lastEmailMessage?.replyType?.title?.toLowerCase();
    if (
      handlers.onMarkAsReplied &&
      currentStatus !== 'replied'&&
      currentStatus !== 'resolved' &&
      currentStatus !== 'closed'
    ){
      actions.push({
        label: 'Mark as Replied',
        onClick: () => handlers.onMarkAsReplied!(row),
        icon: <Mail className="w-4 h-4" />,
        className: 'text-yellow-600 hover:text-green-700',
      });
    }
    if (
      handlers.onMarkAsResolved &&
      currentStatus !== 'resolved' &&
      currentStatus !== 'closed'
    ) {
      actions.push({
        label: 'Mark as Resolved',
        onClick: () => handlers.onMarkAsResolved!(row),
        icon: <CheckCircle className="w-4 h-4" />,
        className: 'text-green-600 hover:text-green-700',
      });
    }

    actions.push({
      label: 'Delete Thread',
      onClick: () => handlers.onDelete(row),
      icon: <Trash2 className="w-4 h-4" />,
      confirmMessage: 'Are you sure you want to delete this email thread?',
      className: 'text-red-600 hover:text-red-700',
    });

    return actions;
  };

export default createEmailMessageThreadActions;
